<nb-layout>
  <nb-layout-header fixed>
    <div class="flex-container" style="width: 100%; display: flex;">
      <div class="text-left" style="flex-grow: 1">
        <button nbButton size="large" (click)="toggle()" > <nb-icon icon="menu-outline" ></nb-icon> </button>
      </div>

      <div class="text-left" style="flex-grow: 10">
        <a href="https://dasec.ma">
          <img src="../../assets/logoo.svg" width="150rem">
        </a>
      </div>

      <div class="text-right" style="flex-grow: 30">
        <button nbButton size="large" (click)="openInfo()" > <nb-icon icon="alert-circle-outline" ></nb-icon> </button>

      </div>
    </div>
  </nb-layout-header>

  <nb-sidebar>
    <input nbInput [(ngModel)]="req" (ngModelChange)="refresh()">
    <nb-list [nbSpinner]="isLoading">
      <nb-list-item *ngFor="let item of render['search']"
                    (click)="refreshSeries(item['provider'], item['code'], item)">

        {{item.provider}}- {{item.name}}

      </nb-list-item>
    </nb-list>
  </nb-sidebar>

  <nb-layout-column>


    <div class="row" [nbSpinner]="isLoading2">


        <div class="col-6" *ngFor="let item of render['catalog']">
          <nb-card>
            <nb-card-header>{{item.data[0].label}}</nb-card-header>
            <nb-card-body>
              <ngx-chartjs-line [data]=" {'datasets': item.data, 'labels': item.labels}" ></ngx-chartjs-line>
            </nb-card-body>
          </nb-card>
        </div>

    </div>


  </nb-layout-column>



</nb-layout>
